import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net';
import { useLocation, useNavigate } from "react-router";
import baseConfig from "../../core/config/Config";
import {UserService} from "./Service";



const ManageCards = ({user, refresh}) => {
    const [userService] = useState(new UserService());
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        getData();
    }, [refresh]);

    const getData = () => {
        try {
            $('#table').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token')
        $('#table').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data, type, row) {
                        return `<a href="${data}" target="_blank">${data}</a>`;
                    },
                    "targets": 1
                },
                {

                    "render": function (data, type, row) {
                        return `<div id="qrcode-${row[0]}"></div>`;
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).find(`#qrcode-${rowData[0]}`).html(`
                        <script>
                            new QRCode(document.getElementById("qrcode-${rowData[0]}"), "${cellData}");
                        </script>
                        `);
                    },
                    "targets": 2
                },
                {

                    "render": function (data, type, row) {
                        return `<p class="text-success">#${data}</p>`;
                    },
                    "targets": 3
                },
            ],
            ajax: {
                url: `${baseConfig.apiBaseUrl}/user/cards`,
                type: "POST",
                contentType: "application/json",
                headers: {
                    "Authorization": token,
                },
                data: function (d) {
                    return JSON.stringify({
                        ...d,
                        user: user
                    });
                },
            }
        });
    }

    return (
        <div>

            <div className="card mt-3">
                <div className="card-header p-3">
                    <h5 className="card-title">Manage Cards</h5>
                </div>
                <div className="card-body">
                    <div className='table-responsive w-100'>
                        <table
                            id="table"
                            className='table datatable w-100'
                        >
                            <thead>
                            <tr>
                                <th>Username</th>
                                <th>Link</th>
                                <th>QR</th>
                                <th>Order ID</th>
                                <th>Created Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default ManageCards;
